import React from "react";
import "./error.css";

export default function Error({text}) {
    return <div className="error">{text}</div>;
}
